/* eslint-disable max-lines */
import {
  Advantages,
  AlmostThere,
  AlmostThereV2,
  AlmostThereV4,
  AlternativeAyahLoader,
  AngerCycle,
  AnimatedStepFactory,
  AppWellness,
  AttachmentSummaryV3,
  BreakAyahV1,
  BreakAyahV2,
  BreakAyahV3,
  BreakBuildingProfile,
  BreakDidGreat,
  BreakDoorOpens,
  BreakEveryHeart,
  BreakGatheredProfile,
  BreakHalfway,
  BreakNotPerfect,
  BreakQuizStart,
  BreakRightPlace,
  BreakRightPlaceV2,
  BreakShortSessions,
  BuddhistArchetype,
  CalmFirstLesson,
  CommitmentPromise,
  CreatePlan,
  DangerousSymptoms,
  DeenProfile,
  DependenceSummary,
  DependenceSummaryV2,
  DidYouKnowLoader,
  DownloadWellness,
  EmotionalBlockage,
  EnergyField,
  FaithGrowthProfile,
  FamiliesLearning,
  FinalTouch,
  FromUsers,
  FromUsersFactory,
  FromUsersVariant3,
  GodSpeakToYou,
  GrowthProfile,
  GuidanceQuotePage,
  HardToNavigate,
  IntroLoaderAyah,
  IntroLoaderKarma,
  IntroPrintable,
  IntroPrintableAyah,
  JoinCommunity,
  KnowledgeQuizIntro,
  LandingWellness,
  LearnedResponse,
  LetUsKnow,
  LetUsKnowKarma,
  ListenTogether,
  MillionSouls,
  MoneyBreakV1,
  MoneyBreakV2,
  MoneyBreakV3,
  Name,
  NameV2,
  NearRelief,
  NextStep,
  ParentingProfile,
  PeopleLikeYou,
  PersonalGrowthProgressV2,
  PersonalGrowthProgressV3,
  PersonalizedPlanKarma,
  Presence,
  ProfileSdAyah,
  ProfileWType,
  QuoteBreak,
  ReservedPlan,
  RestfulNights,
  Scratch,
  SimpleIslam,
  SpiritualityBenefits,
  StableIntro,
  StartQuizAyah,
  TaiChiEnergyFlow,
  ThankYou,
  ThankYouV2,
  TransformFaith,
  TransformLife,
  TransformLifeKarma,
  WantGoDeeper,
  WelcomePath,
  WritingYourStory,
} from 'pages'
import {
  Abilities,
  AdditionalResources,
  AdditionalResourcesAyah,
  AdditionalResourcesKarma,
  AdviceAyah,
  AffectedAria,
  AfterOverreacting,
  AgeFactory,
  AkhirahFeeling,
  AllahConnection,
  AllahInTenseMoments,
  AlwaysBusy,
  AnalyzingAnswers,
  AnalyzingAnswersAyah,
  AnalyzingAnswersBlessV4,
  AnalyzingAnswersKarma,
  AnalyzingAnswersV5,
  Angry,
  AntistressMusic,
  AriasToImprove,
  AriasToImproveV2,
  AriasToImproveV3,
  AriasToImproveV4,
  AriasToSupport,
  AspectToImprove,
  AttendCommunity,
  AyahGender,
  AyahGenderFactory,
  AyahGenderV2,
  AyahGoal,
  BackgroundMusic,
  BedtimeSunnah,
  BestTime,
  BetterFinances,
  BibleContent,
  BibleContentV3,
  BibleJourney,
  BibleLessonsStyle,
  BiblePurpose,
  BibleVersion,
  BiggestFinancialStruggle,
  BismillahSurah,
  BoredomScrolling,
  BuddhistPractice,
  BudgetConfidence,
  CalmDownAyah,
  CareAyah,
  ChallengeAreasFactory,
  ChildCloseness,
  ChildDisobeys,
  ChildDuas,
  ChildFaithWorries,
  ChildQuranRoutine,
  ChildTantrums,
  ChildWorldView,
  ChildhoodExperience,
  ChildrenAge,
  ChildrenCount,
  CloseToGod,
  CommitmentLevel,
  ConcentrationImpact,
  ConnectedToAllah,
  ConnectedToGod,
  ContentType,
  ContentTypeV2,
  Criticize,
  CurrentChallenges,
  CurrentLifestyle,
  DailyGoal,
  DailyMinutes,
  DailyPractice,
  DeepingFaith,
  DescribeChallenge,
  DesiredReaction,
  DigestionQuality,
  DiscoverAyah,
  DisobeyReaction,
  DistanceBetweenAllah,
  DistanceBetweenYouAndGod,
  DiveDeeper,
  DopamineBalance,
  DopamineDetox,
  DopamineEffect,
  DuaUnderStress,
  EmotionsInFamily,
  EnergyLately,
  EnergyLevel,
  EnergyLevelKarma,
  EnjoyListeningAyah,
  EnjoyListeningDaily,
  EnjoyListeningKarma,
  EnjoyReadingAyah,
  EnjoyReadingDaily,
  Exercise,
  ExplicitContent,
  ExtraTools,
  ExtraToolsV2,
  FaithDecisions,
  FaithExample,
  FaithInWellness,
  FaithObstacleDetails,
  FaithRelationship,
  FamiliarWithConcept,
  FamilyBondGoal,
  FamilyReaction,
  FamilyShapeV2,
  FatihahMeaning,
  FeelAfter,
  FeelBetterAbout,
  FeelExhausted,
  FeelScripture,
  FeelStressed,
  FeelTired,
  FeelingLately,
  FeelingType,
  FinanceStress,
  FinancialMindset,
  GrowPurpose,
  GuideFrequency,
  GuidesToListen,
  Guilty,
  GuiltyTypeAyah,
  HabitTriggers,
  HalalHaramCards,
  HardFaithQuestions,
  HardToAchieve,
  HearOwnParents,
  HeavyLife,
  Hello,
  HelpFromAllah,
  HighestHope,
  HomeTriggers,
  HonestQuestion,
  IdealPlace,
  IdentityPride,
  ImanExample,
  IncomeStability,
  InspirationAyah,
  InspiredScripture,
  InstinctAyah,
  IssueDuration,
  IssueDurationV2,
  KarmaContent,
  KarmaGoal,
  KnockTimes,
  KnownIngredients,
  LastTimeFocused,
  LearnFirst,
  LearningReason,
  LearningStyle,
  LessonLength,
  LifeImpact,
  LifeVision,
  LifeWithoutAddiction,
  LosingTemper,
  LostInterest,
  LostMoney,
  MainFinancialGoal,
  MakeYouFeel,
  MattersMost,
  MeaningfulStudy,
  MindAyah,
  MoneyInLife,
  MoneyVision,
  MonthAheadGoal,
  MoreToLearn,
  MostInspired,
  MostInspiredAyah,
  MostInspiredKarma,
  MotivationLevel,
  MotivationLevelV2,
  MovingStory,
  MultiAyahGoal,
  MultiChallengeAreas,
  MuslimBackground,
  MuslimGoal,
  NarratorVoice,
  NaturalRemedies,
  NegativeEffect,
  NegativeSituations,
  NewChallengeAyah,
  NewThings,
  ObstaclesToStudy,
  OnlineDaily,
  OtherOpinion,
  OthersFirst,
  Outcome,
  OverallState,
  Overwhelmed,
  ParentFears,
  ParentWorriesSingle,
  ParentingLoad,
  ParentingOverwhelm,
  PartsToExplore,
  PeopleLove,
  PersonalNeed,
  PlanPreparationAyah,
  PlanPreparationKarma,
  PlanToUse,
  PlansFallApart,
  PornToCope,
  PositiveHabits,
  PotentialBlock,
  PracticeSpiritual,
  PrayerLife,
  PrayerType,
  PrayersSlip,
  PresentStruggles,
  PromicesAyah,
  PsalmsUnderstanding,
  PushToPractice,
  QuitGoal,
  QuoteAyah,
  QuranAtHome,
  QuranContent,
  QuranContentV2,
  QuranDiscussion,
  QuranGoal,
  QuranLessons,
  QuranLevel,
  QuranStage,
  QuranStudyTime,
  QuranTimeFit,
  QuranWoman,
  RaisedAsChild,
  ReactionGuilt,
  ReadListenQuran,
  ReadOrListen,
  ReadingPlaceAyah,
  ReadyToBegin,
  ReadyToGrowCloser,
  ReadyToRenewal,
  ReasonFeelingWorse,
  RechargeWay,
  ReferredBy,
  ReflectionResult,
  RelationshipGoingOn,
  RelationshipStatus,
  RelationshipWithCaregiver,
  RelationshipWithGod,
  Rest,
  SabrChallenge,
  SalahLife,
  SalahMeaning,
  ScreenStruggle,
  ScreensInterrupt,
  SelectAgeV2,
  SelectAgeV3,
  SelectAgeV4,
  SelectFamilySize,
  SelectFocusArea,
  SelectGenderArchetype,
  SelectGenderAyah,
  SelectGenderBlessV3,
  SelectGenderKarma,
  SelectGenderList,
  SelectGenderParent,
  SelectGenderV2,
  ShowLove,
  SinglePresentStruggles,
  SleepIssues,
  SleepQuality,
  SpeakArabic,
  SpiritualActivities,
  StableContinue,
  StableQuestion,
  StartMore,
  StartWith,
  StayFocused,
  StayMotivated,
  StayOnTrack,
  StoryAyah,
  StressCosts,
  StressLevel,
  StressTriggers,
  StructuredRoutine,
  StruggleFinances,
  StruggleWithInsomnia,
  StudyBuddhism,
  StudyQuran,
  StudyQuranBest,
  StudyTheBible,
  SupportGoals,
  SurahUnderstanding,
  TemperAftermath,
  TestAlcohol,
  TestCoffee,
  TestTattoo,
  TimeToStudyBible,
  TrackYourProgress,
  TransformChallengeAreas,
  TranslationQuran,
  TriedSunnahRemedies,
  TriedToStop,
  TurnOnReminders,
  TurnOnRemindersAyah,
  TurnToAllah,
  TurnToGod,
  TypicalDay,
  Uncomfortable,
  UpbringingToAvoid,
  WealthPrinciples,
  WellnessSupportTime,
  WhatBroughtYou,
  WhenToStudy,
  WipesSins,
  WisdomOfProverbs,
} from 'pages/questions'

import {
  CancelOfferQuestionV1,
  CancelOfferQuestionV2,
  CancelOfferQuestionV3,
  CancelOfferSubscriptionV1,
  CancelOfferSubscriptionV2,
  CancelOfferSubscriptionV3,
  CancelOfferSubscriptionV4,
  CancelOfferSubscriptionV5,
  ChooseTrialPrice,
  InappHowTo,
  InappPodcast,
  InappStressRelive,
  InappUpsell,
  InappVoiceover,
  InappVoiceover2,
  InappVoiceoverV3,
  PaymentLong,
  PaywallArchetypeAyah,
  PaywallUS,
  PurchaseLong,
  PurchaseLongV2,
  PurchaseLongV3Factory,
  PurchaseLongV4,
  PurchaseLongV5,
  PurchaseLongV6,
  PurchaseV3KarmaTrial,
  UpsellAddonsAyah,
  UpsellAyahPornAddiction,
  UpsellCancelQuestion,
  UpsellGuide,
  UpsellParenting,
  UpsellPodcast,
  WellnessPaywall,
} from 'modules/purchase/pages'
import {
  Account,
  Email,
  EmailConsentVariant1,
  EmailFactory,
  EmailV1,
  SignUp,
} from 'modules/registration/pages'

import { TIdToPageMap } from 'models/common.model'

export const enum CustomPageId {
  GENDER = 'selectGender',
  AGE = 'selectAge',
  MAIN_STRUGGLE = 'mainStruggle',
  GOAL = 'goal',
  NAME = 'name',
  RELATIONSHIP = 'relationship',
}

export const enum PageId {
  LANDING_WELLNESS = 'landingWellness',
  INTRO_PRINTABLE = 'introPrintable',
  INTRO_PRINTABLE_AYAH = 'introPrintableAyah',
  ALTERNATIVE_AYAH_LOADER = 'alternativeAyahLoader',
  INTRO_KARMA_V1 = 'introKarmaV1',
  INTRO_AYAH_V1 = 'introAyahV1',
  START_QUIZ_AYAH = 'startQuizAyah',
  DID_YOU_KNOW_LOADER = 'didYouKnowLoader',
  REVIEWS = 'reviews',
  PURCHASE_V2 = 'purchaseV2',
  DOWNLOAD = 'download',
  CHECK_INBOX = 'checkInbox',
  HELLO = 'hello',
  ADVANTAGES = 'advantages',
  BUDDHIST_ARCHETYPE = 'buddhistArchetype',
  TAI_CHI_ENERGY_FLOW = 'taiChiEnergyFlow',
  ENERGY_FIELD = 'energyField',
  EMOTIONAL_BLOCKAGE = 'emotionalBlockage',
  PROFILE_W_TYPE = 'profileWType',
  PROFILE_SD_AYAH = 'profileSdAyah',
  PROFILE = 'profile',
  ABILITIES = 'abilities',
  NEW_THINGS = 'newThings',
  GUILTY = 'guilty',
  GUILTY_TYPE_AYAH = 'guiltyTypeAyah',
  PROMICES_AYAH = 'promicesAyah',
  QUOTE_AYAH = 'quoteAyah',
  STORY_AYAH = 'storyAyah',
  TYPICAL_DAY = 'typicalDay',
  CALM_DOWN_AYAH = 'calmDownAyah',
  OTHER_OPINION = 'otherOpinion',
  INSTINCT_AYAH = 'instinctAyah',
  INSPIRATION_AYAH = 'inspirationAyah',
  CARE_AYAH = 'careAyah',
  STAY_ON_TRACK = 'stayOnTrack',
  MIND_AYAH = 'mindAyah',
  NEW_CHALLENGE_AYAH = 'newChallengeAyah',
  READ_LISTEN_QURAN = 'readListenQuran',
  READING_PLACE_AYAH = 'readingPlaceAyah',
  ADVICE_AYAH = 'adviceAyah',
  DISCOVER_AYAH = 'discoverAyah',
  QURAN_DISCUSSION = 'quranDiscussion',
  ANGRY = 'angry',
  NEGATIVE_SITUATIONS = 'negativeSituations',
  OVERWHELMED = 'overwhelmed',
  OUTCOME = 'outcome',
  CRITICIZE = 'criticize',
  UNCOMFORTABLE = 'uncomfortable',
  REST = 'rest',
  ANALYZING_LOADER = 'analyzingLoader',
  CREATE_PLAN = 'createPlan',
  PRAYER_LIFE = 'prayerLife',
  SALAH_LIFE = 'salahLife',
  SALAH_MEANING = 'salahMeaning',
  FATIHAH_MEANING = 'fatihahMeaning',
  AKHIRAH_FEELING = 'akhirahFeeling',
  MONTH_AHEAD_GOAL = 'monthAheadGoal',
  HELP_FROM_ALLAH = 'helpFromAllah',
  WHEN_TO_STUDY = 'whenToStudy',
  QURAN_GOAL = 'quranGoal',
  IMAN_EXAMPLE = 'imanExample',
  FROM_USERS = 'fromUsers',
  FROM_USERS_V2 = 'fromUsersV2',
  FROM_USERS_V3 = 'fromUsersV3',
  BREAK_AYAH = 'breakAyah1',
  BREAK_AYAH_2 = 'breakAyah2',
  BREAK_AYAH_3 = 'breakAyah3',
  BREAK_RIGHT_PLACE = 'breakRightPlace',
  BREAK_RIGHT_PLACE_V2 = 'breakRightPlaceV2',
  BREAK_NOT_PERFECT = 'breakNotPerfect',
  BREAK_DOOR_OPENS = 'breakDoorOpens',
  BREAK_BUILDING_PROFILE = 'breakBuildingProfile',
  BREAK_NAMING_COURAGE = 'breakNamingCourage',
  BREAK_GOAL_NAMED = 'breakGoalNamed',
  MONEY_BREAK_V1 = 'moneyBreakV1',
  MONEY_BREAK_V2 = 'moneyBreakV2',
  MONEY_BREAK_V3 = 'moneyBreakV3',
  GUIDANCE_QUOTE_V1 = 'guidanceQuoteV1',
  GUIDANCE_QUOTE_V2 = 'guidanceQuoteV2',
  WEALTH_PRINCIPLES = 'wealthPrinciples',
  FINANCE_STRESS_LEVEL = 'financeStressLevel',
  FAITH_DECISIONS = 'faithDecisions',
  ANIMATED_BREAK = 'animatedBreak',
  COMMITMENT_LEVEL = 'commitmentLevel',
  COMMITMENT_PROMISE = 'commitmentPromise',
  STRUGGLE_FINANCES = 'struggleFinances',
  STRESS_TRIGGERS = 'stressTriggers',
  STRESS_COSTS = 'stressCosts',
  MONEY_IN_LIFE = 'moneyInLife',
  MONEY_VISION = 'moneyVision',
  BETTER_FINANCES = 'betterFinances',
  LET_US_KNOW = 'letUsKnow',
  LET_US_KNOW_KARMA = 'letUsKnowKarma',
  BIBLE_PRAYER = 'biblePrayer',
  MEDITATION_PRAYER = 'meditationPrayer',
  REFLACTION_PRAYER = 'reflactionPrayer',
  ROSARY_PRAYER = 'rosaryPrayer',
  GUIDES_TO_LISTEN = 'guidesToListen',
  RESERVED_PLAN = 'reservedPlan',
  WHANT_GO_DEEPER = 'whantGoDeeper',
  BIBLE_PURPOSE = 'biblePurpose',
  READ_OR_LISTEN = 'readOrListen',
  ANTISTRESS_MUSIC = 'antistressMusic',
  BACKGROUND_MUSIC = 'backgroundMusic',
  BACKGROUND_MUSIC_V2 = 'backgroundMusicV2',
  TRANSFORM_FAITH = 'transformFaith',
  SELECT_GENDER_V2 = 'selectGenderV2',
  SELECT_GENDER = 'selectGender',
  SELECT_GENDER_V3 = 'selectGenderV3',
  SELECT_GENDER_KARMA = 'selectGenderKarma',
  SELECT_GENDER_AYAH = 'selectGenderAyah',
  AYAH_GENDER = 'ayahGender',
  AYAH_GENDER_FACTORY = 'ayahGenderFactory',
  AYAH_GENDER_V2 = 'ayahGenderV2',
  SELECT_GENDER_PARENT = 'selectGenderParent',
  SELECT_GENDER_ARCHETYPE = 'selectGenderArchetype',
  PEOPLE_LOVE = 'peopleLove',
  RECHARGE_WAY = 'rechargeWay',
  SHOW_LOVE = 'showLove',
  PLANS_FALL_APART = 'plansFallApart',
  ALWAYS_BUSY = 'alwaysBusy',
  START_MORE = 'startMore',
  HOME_TRIGGERS = 'homeTriggers',
  OTHERS_FIRST = 'othersFirst',
  PRAYERS_SLIP = 'prayersSlip',
  FAMILY_REACTION = 'familyReaction',
  BREAK_GATHERED_PROFILE = 'breakGatheredProfile',
  KNOWLEDGE_QUIZ_INTRO = 'knowledgeQuizIntro',
  HALAL_HARAM_CARDS = 'halalHaramCards',
  MUSLIM_GOAL = 'muslimGoal',
  DEEN_PROFILE = 'deenProfile',
  BREAK_DID_GREAT = 'breakDidGreat',
  LEARNING_REASON = 'learningReason',
  LEARN_FIRST = 'learnFirst',
  HONEST_QUESTION = 'honestQuestion',
  BREAK_HALFWAY = 'breakHalfway',
  BREAK_QUIZ_START = 'breakQuizStart',
  BREAK_EVERY_HEART = 'breakEveryHeart',
  QURAN_STAGE = 'quranStage',
  KNOCK_TIMES = 'knockTimes',
  QURAN_WOMAN = 'quranWoman',
  BISMILLAH_SURAH = 'bismillahSurah',
  LOST_MONEY = 'lostMoney',
  WIPES_SINS = 'wipesSins',
  MOVING_STORY = 'movingStory',
  SUPPORT_GOALS = 'supportGoals',
  QURAN_LEVEL = 'quranLevel',
  BEST_TIME = 'bestTime',
  DAILY_MINUTES = 'dailyMinutes',
  BREAK_SHORT_SESSIONS = 'breakShortSessions',
  STABLE_INTRO = 'stableIntro',
  STABLE_QUESTION = 'stableQuestion',
  STABLE_CONTINUE = 'stableContinue',
  LEARNED_RESPONSE = 'learnedResponse',
  JOIN_COMMUNITY = 'joinCommunity',
  CHILDREN_COUNT = 'childrenCount',
  QURAN_AT_HOME = 'quranAtHome',
  CHILDREN_AGE = 'childrenAge',
  FAMILY_SHAPE_V2 = 'familyShapeV2',
  CHILD_QURAN_ROUTINE = 'childQuranRoutine',
  HARD_FAITH_QUESTIONS = 'hardFaithQuestions',
  PARENT_WORRIES_SINGLE = 'parentWorriesSingle',
  CHILD_DISOBEYS = 'childDisobeys',
  LOSING_TEMPER = 'losingTemper',
  SCREENS_INTERRUPT = 'screensInterrupt',
  RAISED_AS_CHILD = 'raisedAsChild',
  UPBRINGING_TO_AVOID = 'upbringingToAvoid',
  IDENTITY_PRIDE = 'identityPride',
  HIGHEST_HOPE = 'highestHope',
  START_WITH = 'startWith',
  STUDY_QURAN_BEST = 'studyQuranBest',
  CHILD_WORLD_VIEW = 'childWorldView',
  SCREEN_STRUGGLE = 'screenStruggle',
  PARENT_FEARS = 'parentFears',
  CHILD_TANTRUMS = 'childTantrums',
  REACTION_GUILT = 'reactionGuilt',
  AFTER_OVERREACTING = 'afterOverreacting',
  FAMILY_BOND_GOAL = 'familyBondGoal',
  QURAN_TIME_FIT = 'quranTimeFit',
  CHILD_DUAS = 'childDuas',
  LISTEN_TOGETHER = 'listenTogether',
  BEDTIME_SUNNAH = 'bedtimeSunnah',
  SELECT_FAMILY_SIZE = 'selectFamilySize',
  SELECT_GENDER_LIST = 'selectGenderList',
  PARENTING_LOAD = 'parentingLoad',
  FEELING_LATELY = 'feelingLately',
  PARENTING_OVERWHELM = 'parentingOverwhelm',
  SABR_CHALLENGE = 'sabrChallenge',
  CHILD_CLOSENESS = 'childCloseness',
  DISOBEY_REACTION = 'disobeyReaction',
  TEMPER_AFTERMATH = 'temperAftermath',
  HEAR_OWN_PARENTS = 'hearOwnParents',
  ANGER_CYCLE = 'angerCycle',
  PUSH_TO_PRACTICE = 'pushToPractice',
  ALLAH_IN_TENSE_MOMENTS = 'allahInTenseMoments',
  CHILD_FAITH_WORRIES = 'childFaithWorries',
  ALLAH_CONNECTION = 'allahConnection',
  DUA_UNDER_STRESS = 'duaUnderStress',
  DESIRED_REACTION = 'desiredReaction',
  CALM_FIRST_LESSON = 'calmFirstLesson',
  PARENTING_PROFILE = 'parentingProfile',
  AGE_FACTORY = 'ageFactory',
  SELECT_AGE_V2 = 'selectAgeV2',
  SELECT_AGE_V3 = 'selectAgeV3',
  SELECT_AGE_V4 = 'selectAgeV4',
  MUSLIM_BACKGROUND = 'muslimBackground',
  SELECT_FOCUS_AREA = 'selectFocusArea',
  FEEL_BETTER_ABOUT = 'feelBetterAbout',
  ENERGY_LATELY = 'energyLately',
  SLEEP_QUALITY = 'sleepQuality',
  FEEL_STRESSED = 'feelStressed',
  DIGESTION_QUALITY = 'digestionQuality',
  KNOWN_INGREDIENTS = 'knownIngredients',
  FAITH_IN_WELLNESS = 'faithInWellness',
  NATURAL_REMEDIES = 'naturalRemedies',
  TRIED_SUNNAH_REMEDIES = 'triedSunnahRemedies',
  WELLNESS_SUPPORT_TIME = 'wellnessSupportTime',
  GUIDE_FREQUENCY = 'guideFrequency',
  WELCOME_PATH = 'welcomePath',
  RESTFUL_NIGHTS = 'restfulNights',
  FAMILIAR_WITH_CONCEPT = 'familiarWithConcept',
  WHAT_BROUGHT_YOU = 'whatBroughtYou',
  RELATIONSHIP_STATUS = 'relationshipStatus',
  RELATIONSHIP_GOING_ON = 'relationshipGoingOn',
  REFLECTION_RESULT = 'reflectionResult',
  STRUGGLE_WITH_INSOMNIA = 'struggleWithInsomnia',
  DESCRIBE_CHALLENGE = 'describeChallenge',
  MILLION_SOULS = 'millionSouls',
  FAMILIES_LEARNING = 'familiesLearning',
  BIBLE_JOURNEY = 'bibleJourney',
  CLOSE_TO_GOD = 'closeToGod',
  HARD_TO_NAVIGATE = 'hardToNavigate',
  FEEL_SCRIPTURE = 'feelScripture',
  FAITH_RELATIONSHIP = 'faithRelationship',
  PLAN_TO_USE = 'planToUse',
  ALMOST_THERE = 'almostThere',
  ALMOST_THERE_V2 = 'almostThereV2',
  ALMOST_THERE_V3 = 'almostThereV3',
  ALMOST_THERE_V4 = 'almostThereV4',
  TEST_ALCOHOL = 'testAlcohol',
  TEST_COFFEE = 'testCoffee',
  TEST_TATTOO = 'testTattoo',
  READY_TO_BEGIN = 'readyToBegin',
  RELATIONSHIP_WITH_GOD = 'relationshipWithGod',
  INSPIRED_SCRIPTURE = 'inspiredScripture',
  TRANSFORM_LIFE = 'transformLife',
  DEEPING_FAITH = 'deepingFaith',
  PARTS_TO_EXPLORE = 'partsToExplore',
  STUDY_THE_BIBLE = 'studyTheBible',
  MEANINGFUL_STUDY = 'meaningfulStudy',
  PRESENCE = 'presence',
  ASPECT_TO_IMPROVE = 'aspectToImprove',
  DAILY_PRACTICE = 'dailyPractice',
  LIFE_VISION = 'lifeVision',
  WRITING_YOUR_STORY = 'writingYourStory',
  MOST_INSPIRED = 'mostInspired',
  MOST_INSPIRED_AYAH = 'mostInspiredAyah',
  MOST_INSPIRED_KARMA = 'mostInspiredKarma',
  BUDDHIST_PRACTICE = 'buddhistPractice',
  KARMA_GOAL = 'karmaGoal',
  KARMA_CONTENT = 'karmaContent',
  LEARNING_STYLE = 'learningStyle',
  LESSON_LENGTH = 'lessonLength',
  TRANSLATION_QURAN = 'translationQuran',
  AYAH_GOAL = 'ayahGoal',
  MULTI_AYAH_GOAL = 'multiAyahGoal',
  SIMPLE_ISLAM = 'simpleIslam',
  IDEAL_PLACE = 'idealPlace',
  TIME_TO_STUDY_BIBLE = 'timeToStudyBible',
  TIME_TO_STUDY_BIBLE_V2 = 'timeToStudyBibleV2',
  STUDY_QURAN = 'studyQuran',
  BIBLE_VERSION = 'bibleVersion',
  SPEAK_ARABIC = 'speakArabic',
  QURAN_LESSONS = 'quranLessons',
  BIBLE_LESSONS_STYLE = 'bibleLessonsStyle',
  ADDITIONAL_RESOURCES = 'additionalResources',
  ADDITIONAL_RESOURCES_AYAH = 'additionalResourcesAyah',
  ADDITIONAL_RESOURCES_KARMA = 'additionalResourcesKarma',
  GOD_SPEAK_TO_YOU = 'godSpeakToYou',
  DIVE_DEEPER = 'diveDeeper',
  PSALMS_UNDERSTANDING = 'psalmsUnderstanding',
  SURAH_UNDERSTANDING = 'surahUnderstanding',
  WISDOM_OF_PROVERBS = 'wisdomOfProverbs',
  ARIAS_TO_IMPROVE = 'ariasToImprove',
  ARIAS_TO_IMPROVE_V2 = 'ariasToImproveV2',
  ARIAS_TO_IMPROVE_V3 = 'ariasToImproveV3',
  ARIAS_TO_IMPROVE_V4 = 'ariasToImproveV4',
  STUDY_BUDDHISM = 'studyBuddhism',
  CHALLENGE_AREAS = 'challengeAreas',
  CHALLENGE_AREAS_AYAH = 'challengeAreasAyah',
  TRANSFORM_CHALLENGE_AREAS = 'transformChallengeAreas',
  DAILY_GOAL = 'dailyGoal',
  ATTEND_COMMUNITY = 'attendCommunity',
  STRUCTURED_ROUTINE = 'structuredRoutine',
  ONLINE_DAILY = 'onlineDaily',
  EXERCISE = 'exercise',
  PRACTICE_SPIRITUAL = 'practiseSpiritual',
  PORN_TO_COPE = 'pornToCope',
  FEEL_EXHAUSTED = 'feelExhausted',
  FEEL_TIRED = 'feelTired',
  STAY_FOCUSED = 'stayFocused',
  NEXT_STEP = 'nextStep',
  PERSONAL_NEED = 'personalNeed',
  PRESENT_STRUGGLES = 'presentStruggles',
  SINGLE_PRESENT_STRUGGLES = 'singlePresentStruggles',
  FEEL_COMFORTABLE = 'feelComfortable',
  FEEL_STRUGGLE = 'feelStruggle',
  FEEL_DISCOMFORT = 'feelDiscomfort',
  FEEL_PULLED = 'feelPulled',
  FEEL_UNSURE = 'feelUnsure',
  FEEL_LOST = 'feelLost',
  FEEL_WORRY = 'feelWorry',
  FEEL_UNSETTLED = 'feelUnsettled',
  FEEL_CONCERNED = 'feelConcerned',
  CHILDHOOD_EXPERIENCE = 'childhoodExperience',
  RELATIONSHIP_WITH_CAREGIVER = 'relationshipWithCaregiver',
  EMOTIONS_IN_FAMILY = 'emotionsInFamily',
  CURRENT_CHALLENGES = 'currentChallenges',
  POTENTIAL_BLOCK = 'potentialBlock',
  HARD_TO_ACHIEVE = 'hardToAchieve',
  LOST_INTEREST = 'lostInterest',
  BOREDOM_SCROLLING = 'boredomScrolling',
  ENERGY_LEVEL_V2 = 'energyLevelV2',
  ENERGY_LEVEL_KARMA = 'energyLevelKarma',
  ENERGY_LEVEL_AYAH = 'energyLevelAyah',
  SLEEP_ISSUES = 'sleepIssues',
  CONCENTRATION_IMPACT = 'concentrationImpact',
  LIFE_IMPACT = 'lifeImpact',
  MAKE_YOU_FEEL = 'makeYouFeel',
  NEAR_RELIEF = 'nearRelieve',
  AFFECTED_ARIA = 'affectedAria',
  CURRENT_LIFESTYLE = 'currentLifestyle',
  FINANCIAL_MINDSET = 'financialMindset',
  INCOME_STABILITY = 'incomeStability',
  BUDGET_CONFIDENCE = 'budgetConfidence',
  BIGGEST_FINANCIAL_STRUGGLE = 'biggestFinancialStruggle',
  MAIN_FINANCIAL_GOAL = 'mainFinancialGoal',
  OVERALL_STATE = 'overallState',
  REASON_FEELING_WORSE = 'reasonFeelingWorse',
  LAST_TIME_FOCUSED = 'lastTimeFocused',
  DANGEROUS_SYMPTOMS = 'dangerousSymptoms',
  DOPAMINE_EFFECT = 'dopamineEffect',
  DOPAMINE_BALANCE = 'dopamineBalance',
  SPIRITUAL_ACTIVITIES = 'spiritualActivities',
  DOPAMINE_DETOX = 'dopamineDetox',
  GUIT_GOAL = 'quitGoal',
  POSITIVE_HABITS = 'positiveHabits',
  LIFE_WITHOUT_ADDICTION = 'lifeWithoutAddiction',
  REFERRED_BY = 'referredBy',
  REFERRED_BY_V2 = 'referredByV2',
  MOTIVATION_LEVEL = 'motivationLevel',
  MOTIVATION_LEVEL_V2 = 'motivationLevelV2',
  MORE_TO_LEARN = 'moreToLearn',
  DEPENDENCE_SUMMARY = 'dependenceSummary',
  DEPENDENCE_SUMMARY_V2 = 'dependenceSummaryV2',
  ATTACHMENT_SUMMARY = 'attachmentSummary',
  TRACK_YOUR_PROGRESS = 'trackYourProgress',
  THANK_YOU = 'thankYou',
  THANK_YOU_V2 = 'thankYouV2',
  EXPLICIT_CONTENT = 'explicitContent',
  ISSUE_DURATION = 'issueDuration',
  ISSUE_DURATION_V2 = 'issueDurationV2',
  TRIED_TO_STOP = 'triedToStop',
  FEEL_AFTER = 'feelAfter',
  HABIT_TRIGGERS = 'habitTriggers',
  NEGATIVE_EFFECT = 'negativeEffect',
  STRESS_LEVEL = 'stressLevel',
  SPIRITUALITY_BENEFITS = 'spiritualityBenefits',
  BIBLE_CONTENT = 'bibleContent',
  BIBLE_CONTENT_V2 = 'bibleContentV2',
  BIBLE_CONTENT_V3 = 'bibleContentV3',
  QURAN_CONTENT = 'quranContent',
  QURAN_CONTENT_V2 = 'quranContentV2',
  GROWTH_PURPOSE = 'growPurpose',
  NARRATOR_VOICE = 'narratorVoice',
  NARRATOR_VOICE_V2 = 'narratorVoiceV2',
  TURN_ON_REMINDERS = 'turnOnReminders',
  TURN_ON_REMINDERS_AYAH = 'turnOnRemindersAyah',
  ENJOY_READING_DAILY = 'enjoyReadingDaily',
  ENJOY_READING_AYAH = 'enjoyReadingAyah',
  ENJOY_LISTENING_DAILY = 'enjoyListeningDaily',
  ENJOY_LISTENING_AYAH = 'enjoyListeningAyah',
  ENJOY_LISTENING_KARMA = 'enjoyListeningKarma',
  PEOPLE_LIKE_YOU = 'peopleLikeYou',
  FINAL_TOUCH = 'finalTouch',
  TURN_TO_GOD = 'turnToGod',
  TURN_TO_ALLAH = 'turnToAllah',
  HEAVY_LIFE = 'heavyLife',
  DISTANCE_BETWEEN_YOU_AND_GOD = 'distanceBetweenYouAndGod',
  DISTANCE_BETWEEN_ALLAH = 'distanceBetweenAllah',
  OBSTACLES_TO_STUDY = 'obstaclesToStudy',
  FAITH_OBSTACLE_DETAILS = 'faithObstacleDetails',
  FAITH_EXAMPLE = 'faithExample',
  STAY_MOTIVATED = 'stayMotivated',
  ARIAS_TO_SUPPORT = 'ariasToSupport',
  CONTENT_TYPE = 'contentType',
  CONTENT_TYPE_V2 = 'contentTypeV2',
  READY_TO_GROW_CLOSER = 'readyToGrowCloser',
  QURAN_STUDY_TIME = 'quranStudyTime',
  CONNECTED_TO_GOD = 'connectedToGod',
  CONNECTED_TO_ALLAH = 'connectedToAllah',
  MATTERS_MOST = 'mattersMost',
  EXTRA_TOOLS = 'extraTools',
  EXTRA_TOOLS_V2 = 'extraToolsV2',
  READY_TO_RENEWAL = 'readyToRenewal',
  GROWTH_PROFILE = 'growthProfile',
  PERSONAL_GROWTH_PROGRESS = 'personalGrowthProgress',
  PERSONAL_GROWTH_PROGRESS_V2 = 'personalGrowthProgressV2',
  PERSONAL_GROWTH_PROGRESS_V3 = 'personalGrowthProgressV3',
  PERSONAL_GROWTH_PROGRESS_V4 = 'personalGrowthProgressV4',
  PERSONALIZED_PLAN_KARMA = 'personalizedPlanKarma',
  TRANSFORM_LIFE_KARMA = 'transformLifeKarma',
  ANALYZING_ANSWERS = 'analyzingAnswers',
  ANALYZING_ANSWERS_AYAH = 'analyzingAnswersAyah',
  ANALYZING_ANSWERS_KARMA = 'analyzingAnswersKarma',
  ANALYZING_ANSWERS_BLESS = 'analyzingAnswersBless',
  PLAN_PREPARATION_KARMA = 'planPreparationKarma',
  PLAN_PREPARATION_AYAH = 'planPreparationAyah',
  SCRATCH_CARD = 'scratchCard',
  NAME = 'name',
  NAME_V2 = 'nameV2',
  EMAIL_V2 = 'emailV2',
  EMAIL_V1 = 'emailV1',
  EMAIL_FACTORY = 'emailFactory',
  EMAIL_CONSENT_V1 = 'emailConsentV1',
  EMAIL_WELLNESS = 'emailWellness',
  DOWNLOAD_WELLNESS = 'downloadWellness',
  APP_WELLNESS = 'appWellness',
  TRIAL_CHOICE = 'trialChoice',
  PURCHASE_LONG = 'purchaseLong',
  PURCHASE_LONG_V2 = 'purchaseLongV2',
  PURCHASE_LONG_V3 = 'purchaseLongV3',
  PURCHASE_V3_KARMA_TRIAL = 'purchaseKarmaTrial',
  PURCHASE_LONG_V4 = 'purchaseLongV4',
  PURCHASE_LONG_V5 = 'purchaseLongV5',
  PURCHASE_LONG_V6 = 'purchaseLongV6',
  PURCHASE_ARCHETYPE_AYAH = 'purchaseArchAyah',
  PURCHASE_AM = 'purchaseAM',
  WELLNESS_PAYWALL = 'wellnessPaywall',
  UPSELL_GUIDE = 'upsellGuide',
  UPSELL_GUIDE_V2 = 'upsellGuideV2',
  UPSELL_PODCAST = 'upsellPodcast',
  INAPP_PODCAST = 'inappPodcast',
  UPSELL_AYAH_PA = 'upsellAyahPA',
  UPSELL_CANCEL_QUESTION_AYAH = 'upsellCancelOfferQuestion',
  UPSELL_CANCEL_OFFER_V1 = 'upsellCancelOfferV1',
  UPSELL_ADDONS_AYAH = 'upsellAddonsAyah',
  INAPP_VOICEOVER = 'inappVoiceover',
  INAPP_VOICEOVER_2 = 'inappVoiceover2',
  INAPP_VOICEOVER_V3 = 'inappVoiceoverV3',
  UPSELL_PARENTING = 'upsellParenting',
  INAPP_HOW_TO = 'inappHowTo',
  INAPP_STRESS_RELIVE = 'inappStressRelive',
  PAYMENT = 'payment',
  PAYMENT_V2 = 'paymentV2',
  SIGNUP = 'signup',
  ACCOUNT = 'account',
  CANCEL_OFFER_QUESTION_V1 = 'cancelOfferQuestionV1',
  CANCEL_OFFER_QUESTION_V2 = 'cancelOfferQuestionV2',
  CANCEL_OFFER_QUESTION_V3 = 'cancelOfferQuestionV3',
  CANCEL_OFFER_SUBSCRIPTION_V1 = 'cancelOfferSubscriptionV1',
  CANCEL_OFFER_SUBSCRIPTION_V2 = 'cancelOfferSubscriptionV2',
  CANCEL_OFFER_SUBSCRIPTION_V3 = 'cancelOfferSubscriptionV3',
  CANCEL_OFFER_SUBSCRIPTION_V4 = 'cancelOfferSubscriptionV4',
  CANCEL_OFFER_SUBSCRIPTION_V5 = 'cancelOfferSubscriptionV5',
  TERMS_OF_USE = 'terms-of-use',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIE_POLICY = 'cookie-policy',
}

export const EMAIL_PAGE_IDS: readonly PageId[] = [
  PageId.EMAIL_V1,
  PageId.EMAIL_V2,
  PageId.EMAIL_FACTORY,
]

export const INTRO_LOADER_PAGE_IDS: readonly PageId[] = [
  PageId.ALTERNATIVE_AYAH_LOADER,
  PageId.DID_YOU_KNOW_LOADER,
  PageId.INTRO_AYAH_V1,
  PageId.INTRO_KARMA_V1,
  PageId.KNOWLEDGE_QUIZ_INTRO,
]

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  // Intro
  [PageId.LANDING_WELLNESS]: LandingWellness,
  [PageId.INTRO_PRINTABLE]: IntroPrintable,
  [PageId.INTRO_PRINTABLE_AYAH]: IntroPrintableAyah,
  [PageId.ALTERNATIVE_AYAH_LOADER]: AlternativeAyahLoader,
  [PageId.TRANSFORM_FAITH]: TransformFaith,
  [PageId.INTRO_KARMA_V1]: IntroLoaderKarma,
  [PageId.INTRO_AYAH_V1]: IntroLoaderAyah,
  [PageId.KNOWLEDGE_QUIZ_INTRO]: KnowledgeQuizIntro,
  [PageId.DID_YOU_KNOW_LOADER]: DidYouKnowLoader,
  // Static
  [PageId.WELCOME_PATH]: WelcomePath,
  [PageId.RESTFUL_NIGHTS]: RestfulNights,
  [PageId.MILLION_SOULS]: MillionSouls,
  [PageId.FAMILIES_LEARNING]: FamiliesLearning,
  [PageId.TRANSFORM_LIFE]: TransformLife,
  [PageId.PRESENCE]: Presence,
  [PageId.NEAR_RELIEF]: NearRelief,
  [PageId.WRITING_YOUR_STORY]: WritingYourStory,
  [PageId.GOD_SPEAK_TO_YOU]: GodSpeakToYou,
  [PageId.SPIRITUALITY_BENEFITS]: SpiritualityBenefits,
  [PageId.FINAL_TOUCH]: FinalTouch,
  [PageId.HARD_TO_NAVIGATE]: HardToNavigate,
  [PageId.DEPENDENCE_SUMMARY]: DependenceSummary,
  [PageId.DEPENDENCE_SUMMARY_V2]: DependenceSummaryV2,
  [PageId.ATTACHMENT_SUMMARY]: AttachmentSummaryV3,
  [PageId.THANK_YOU]: ThankYou,
  [PageId.CREATE_PLAN]: CreatePlan,
  [PageId.FROM_USERS]: FromUsers,
  [PageId.FROM_USERS_V3]: FromUsersVariant3,
  [PageId.FROM_USERS_V2]: FromUsersFactory,
  [PageId.LET_US_KNOW]: LetUsKnow,
  [PageId.LET_US_KNOW_KARMA]: LetUsKnowKarma,
  [PageId.RESERVED_PLAN]: ReservedPlan,
  [PageId.WHANT_GO_DEEPER]: WantGoDeeper,
  [PageId.ALMOST_THERE]: AlmostThere,
  [PageId.ALMOST_THERE_V2]: AlmostThereV2,
  [PageId.ALMOST_THERE_V3]: AlmostThereV2,
  [PageId.ALMOST_THERE_V4]: AlmostThereV4,
  [PageId.DANGEROUS_SYMPTOMS]: DangerousSymptoms,
  [PageId.THANK_YOU_V2]: ThankYouV2,
  [PageId.NEXT_STEP]: NextStep,
  [PageId.ADVANTAGES]: Advantages,
  [PageId.SIMPLE_ISLAM]: SimpleIslam,
  [PageId.BUDDHIST_ARCHETYPE]: BuddhistArchetype,
  [PageId.TAI_CHI_ENERGY_FLOW]: TaiChiEnergyFlow,
  [PageId.ENERGY_FIELD]: EnergyField,
  [PageId.EMOTIONAL_BLOCKAGE]: EmotionalBlockage,
  [PageId.PROFILE_W_TYPE]: ProfileWType,
  [PageId.PROFILE_SD_AYAH]: ProfileSdAyah,
  [PageId.PROFILE]: FaithGrowthProfile,
  [PageId.START_QUIZ_AYAH]: StartQuizAyah,
  [PageId.BREAK_AYAH]: BreakAyahV1,
  [PageId.BREAK_AYAH_2]: BreakAyahV2,
  [PageId.BREAK_AYAH_3]: BreakAyahV3,
  [PageId.BREAK_RIGHT_PLACE]: BreakRightPlace,
  [PageId.BREAK_RIGHT_PLACE_V2]: BreakRightPlaceV2,
  [PageId.BREAK_NOT_PERFECT]: BreakNotPerfect,
  [PageId.BREAK_HALFWAY]: BreakHalfway,
  [PageId.BREAK_QUIZ_START]: BreakQuizStart,
  [PageId.BREAK_EVERY_HEART]: BreakEveryHeart,
  [PageId.BREAK_DID_GREAT]: BreakDidGreat,
  [PageId.BREAK_DOOR_OPENS]: BreakDoorOpens,
  [PageId.BREAK_BUILDING_PROFILE]: BreakBuildingProfile,
  [PageId.BREAK_NAMING_COURAGE]: QuoteBreak,
  [PageId.BREAK_GOAL_NAMED]: QuoteBreak,
  [PageId.MONEY_BREAK_V1]: MoneyBreakV1,
  [PageId.MONEY_BREAK_V2]: MoneyBreakV2,
  [PageId.MONEY_BREAK_V3]: MoneyBreakV3,
  [PageId.GUIDANCE_QUOTE_V1]: GuidanceQuotePage,
  [PageId.GUIDANCE_QUOTE_V2]: GuidanceQuotePage,
  [PageId.WEALTH_PRINCIPLES]: WealthPrinciples,
  // SelectGender
  [PageId.SELECT_GENDER_V2]: SelectGenderV2,
  [PageId.SELECT_GENDER]: SelectGenderAyah,
  [PageId.SELECT_GENDER_AYAH]: SelectGenderAyah,
  [PageId.AYAH_GENDER]: AyahGender,
  [PageId.AYAH_GENDER_FACTORY]: AyahGenderFactory,
  [PageId.AYAH_GENDER_V2]: AyahGenderV2,
  [PageId.SELECT_GENDER_V3]: SelectGenderBlessV3,
  [PageId.SELECT_GENDER_KARMA]: SelectGenderKarma,
  [PageId.SELECT_GENDER_PARENT]: SelectGenderParent,
  [PageId.SELECT_GENDER_ARCHETYPE]: SelectGenderArchetype,
  [PageId.PEOPLE_LOVE]: PeopleLove,
  [PageId.RECHARGE_WAY]: RechargeWay,
  [PageId.SHOW_LOVE]: ShowLove,
  [PageId.PLANS_FALL_APART]: PlansFallApart,
  [PageId.ALWAYS_BUSY]: AlwaysBusy,
  [PageId.START_MORE]: StartMore,
  [PageId.HOME_TRIGGERS]: HomeTriggers,
  [PageId.OTHERS_FIRST]: OthersFirst,
  [PageId.PRAYERS_SLIP]: PrayersSlip,
  [PageId.FAMILY_REACTION]: FamilyReaction,
  [PageId.BREAK_GATHERED_PROFILE]: BreakGatheredProfile,
  [PageId.MUSLIM_GOAL]: MuslimGoal,
  [PageId.LEARNING_REASON]: LearningReason,
  [PageId.LEARN_FIRST]: LearnFirst,
  [PageId.HALAL_HARAM_CARDS]: HalalHaramCards,
  [PageId.HONEST_QUESTION]: HonestQuestion,
  [PageId.QURAN_STAGE]: QuranStage,
  [PageId.KNOCK_TIMES]: KnockTimes,
  [PageId.QURAN_WOMAN]: QuranWoman,
  [PageId.BISMILLAH_SURAH]: BismillahSurah,
  [PageId.LOST_MONEY]: LostMoney,
  [PageId.WIPES_SINS]: WipesSins,
  [PageId.MOVING_STORY]: MovingStory,
  [PageId.SUPPORT_GOALS]: SupportGoals,
  [PageId.QURAN_LEVEL]: QuranLevel,
  [PageId.BEST_TIME]: BestTime,
  [PageId.DAILY_MINUTES]: DailyMinutes,
  [PageId.BREAK_SHORT_SESSIONS]: BreakShortSessions,
  [PageId.STABLE_INTRO]: StableIntro,
  [PageId.STABLE_QUESTION]: StableQuestion,
  [PageId.STABLE_CONTINUE]: StableContinue,
  [PageId.LEARNED_RESPONSE]: LearnedResponse,
  [PageId.JOIN_COMMUNITY]: JoinCommunity,
  [PageId.CHILDREN_COUNT]: ChildrenCount,
  [PageId.QURAN_AT_HOME]: QuranAtHome,
  [PageId.CHILDREN_AGE]: ChildrenAge,
  [PageId.FAMILY_SHAPE_V2]: FamilyShapeV2,
  [PageId.CHILD_QURAN_ROUTINE]: ChildQuranRoutine,
  [PageId.HARD_FAITH_QUESTIONS]: HardFaithQuestions,
  [PageId.PARENT_WORRIES_SINGLE]: ParentWorriesSingle,
  [PageId.CHILD_DISOBEYS]: ChildDisobeys,
  [PageId.LOSING_TEMPER]: LosingTemper,
  [PageId.SCREENS_INTERRUPT]: ScreensInterrupt,
  [PageId.RAISED_AS_CHILD]: RaisedAsChild,
  [PageId.UPBRINGING_TO_AVOID]: UpbringingToAvoid,
  [PageId.IDENTITY_PRIDE]: IdentityPride,
  [PageId.HIGHEST_HOPE]: HighestHope,
  [PageId.START_WITH]: StartWith,
  [PageId.STUDY_QURAN_BEST]: StudyQuranBest,
  [PageId.CHILD_WORLD_VIEW]: ChildWorldView,
  [PageId.SCREEN_STRUGGLE]: ScreenStruggle,
  [PageId.PARENT_FEARS]: ParentFears,
  [PageId.CHILD_TANTRUMS]: ChildTantrums,
  [PageId.REACTION_GUILT]: ReactionGuilt,
  [PageId.AFTER_OVERREACTING]: AfterOverreacting,
  [PageId.FAMILY_BOND_GOAL]: FamilyBondGoal,
  [PageId.QURAN_TIME_FIT]: QuranTimeFit,
  [PageId.CHILD_DUAS]: ChildDuas,
  [PageId.LISTEN_TOGETHER]: ListenTogether,
  [PageId.BEDTIME_SUNNAH]: BedtimeSunnah,
  [PageId.SELECT_FAMILY_SIZE]: SelectFamilySize,
  [PageId.SELECT_GENDER_LIST]: SelectGenderList,
  [PageId.PARENTING_LOAD]: ParentingLoad,
  [PageId.FEELING_LATELY]: FeelingLately,
  [PageId.PARENTING_OVERWHELM]: ParentingOverwhelm,
  [PageId.SABR_CHALLENGE]: SabrChallenge,
  [PageId.CHILD_CLOSENESS]: ChildCloseness,
  [PageId.DISOBEY_REACTION]: DisobeyReaction,
  [PageId.TEMPER_AFTERMATH]: TemperAftermath,
  [PageId.HEAR_OWN_PARENTS]: HearOwnParents,
  [PageId.ANGER_CYCLE]: AngerCycle,
  [PageId.PUSH_TO_PRACTICE]: PushToPractice,
  [PageId.ALLAH_IN_TENSE_MOMENTS]: AllahInTenseMoments,
  [PageId.CHILD_FAITH_WORRIES]: ChildFaithWorries,
  [PageId.ALLAH_CONNECTION]: AllahConnection,
  [PageId.DUA_UNDER_STRESS]: DuaUnderStress,
  [PageId.DESIRED_REACTION]: DesiredReaction,
  [PageId.CALM_FIRST_LESSON]: CalmFirstLesson,
  [PageId.PARENTING_PROFILE]: ParentingProfile,
  [PageId.DEEN_PROFILE]: DeenProfile,
  // SelectAge
  [PageId.AGE_FACTORY]: AgeFactory,
  [PageId.SELECT_AGE_V2]: SelectAgeV2,
  [PageId.SELECT_AGE_V3]: SelectAgeV3,
  [PageId.SELECT_AGE_V4]: SelectAgeV4,
  // MultipleChoice
  [PageId.ARIAS_TO_IMPROVE]: AriasToImprove,
  [PageId.ARIAS_TO_IMPROVE_V2]: AriasToImproveV2,
  [PageId.ARIAS_TO_IMPROVE_V4]: AriasToImproveV4,
  [PageId.PARTS_TO_EXPLORE]: PartsToExplore,
  [PageId.STUDY_THE_BIBLE]: StudyTheBible,
  [PageId.MEANINGFUL_STUDY]: MeaningfulStudy,
  [PageId.DAILY_PRACTICE]: DailyPractice,
  [PageId.LIFE_VISION]: LifeVision,
  [PageId.ADDITIONAL_RESOURCES]: AdditionalResources,
  [PageId.ADDITIONAL_RESOURCES_AYAH]: AdditionalResourcesAyah,
  [PageId.ADDITIONAL_RESOURCES_KARMA]: AdditionalResourcesKarma,
  [PageId.NEGATIVE_EFFECT]: NegativeEffect,
  [PageId.PRACTICE_SPIRITUAL]: PracticeSpiritual,
  [PageId.GUIT_GOAL]: QuitGoal,
  [PageId.POSITIVE_HABITS]: PositiveHabits,
  [PageId.LIFE_WITHOUT_ADDICTION]: LifeWithoutAddiction,
  [PageId.HELLO]: Hello,
  [PageId.GUIDES_TO_LISTEN]: GuidesToListen,
  [PageId.SLEEP_ISSUES]: SleepIssues,
  [PageId.REASON_FEELING_WORSE]: ReasonFeelingWorse,
  [PageId.DOPAMINE_BALANCE]: DopamineBalance,
  [PageId.SPIRITUAL_ACTIVITIES]: SpiritualActivities,
  [PageId.MAKE_YOU_FEEL]: MakeYouFeel,
  [PageId.MAIN_FINANCIAL_GOAL]: MainFinancialGoal,
  [PageId.MORE_TO_LEARN]: MoreToLearn,
  [PageId.CURRENT_CHALLENGES]: CurrentChallenges,
  [PageId.PERSONAL_NEED]: PersonalNeed,
  [PageId.PRESENT_STRUGGLES]: PresentStruggles,
  [PageId.DISTANCE_BETWEEN_YOU_AND_GOD]: DistanceBetweenYouAndGod,
  [PageId.CONNECTED_TO_GOD]: ConnectedToGod,
  [PageId.CONNECTED_TO_ALLAH]: ConnectedToAllah,
  [PageId.MATTERS_MOST]: MattersMost,
  [PageId.EXTRA_TOOLS]: ExtraTools,
  [PageId.EXTRA_TOOLS_V2]: ExtraToolsV2,
  [PageId.MULTI_AYAH_GOAL]: MultiAyahGoal,
  [PageId.DISTANCE_BETWEEN_ALLAH]: DistanceBetweenAllah,
  [PageId.STRESS_TRIGGERS]: StressTriggers,
  [PageId.STRESS_COSTS]: StressCosts,
  // SingleChoice
  [PageId.STRESS_LEVEL]: StressLevel,
  [PageId.BIBLE_JOURNEY]: BibleJourney,
  [PageId.FEEL_SCRIPTURE]: FeelScripture,
  [PageId.FAITH_RELATIONSHIP]: FaithRelationship,
  [PageId.RELATIONSHIP_WITH_GOD]: RelationshipWithGod,
  [PageId.INSPIRED_SCRIPTURE]: InspiredScripture,
  [PageId.DEEPING_FAITH]: DeepingFaith,
  [PageId.ASPECT_TO_IMPROVE]: AspectToImprove,
  [PageId.MOST_INSPIRED]: MostInspired,
  [PageId.MOST_INSPIRED_AYAH]: MostInspiredAyah,
  [PageId.MOST_INSPIRED_KARMA]: MostInspiredKarma,
  [PageId.TRANSLATION_QURAN]: TranslationQuran,
  [PageId.IDEAL_PLACE]: IdealPlace,
  [PageId.TIME_TO_STUDY_BIBLE]: TimeToStudyBible,
  [PageId.TIME_TO_STUDY_BIBLE_V2]: TimeToStudyBible,
  [PageId.BIBLE_VERSION]: BibleVersion,
  [PageId.BIBLE_LESSONS_STYLE]: BibleLessonsStyle,
  [PageId.CLOSE_TO_GOD]: CloseToGod,
  [PageId.ISSUE_DURATION]: IssueDuration,
  [PageId.ISSUE_DURATION_V2]: IssueDurationV2,
  [PageId.TRIED_TO_STOP]: TriedToStop,
  [PageId.FEEL_AFTER]: FeelAfter,
  [PageId.HABIT_TRIGGERS]: HabitTriggers,
  [PageId.STRUCTURED_ROUTINE]: StructuredRoutine,
  [PageId.ONLINE_DAILY]: OnlineDaily,
  [PageId.EXERCISE]: Exercise,
  [PageId.MOTIVATION_LEVEL]: MotivationLevel,
  [PageId.MOTIVATION_LEVEL_V2]: MotivationLevelV2,
  [PageId.PRAYER_LIFE]: PrayerLife,
  [PageId.SALAH_LIFE]: SalahLife,
  [PageId.SALAH_MEANING]: SalahMeaning,
  [PageId.FATIHAH_MEANING]: FatihahMeaning,
  [PageId.AKHIRAH_FEELING]: AkhirahFeeling,
  [PageId.MONTH_AHEAD_GOAL]: MonthAheadGoal,
  [PageId.HELP_FROM_ALLAH]: HelpFromAllah,
  [PageId.WHEN_TO_STUDY]: WhenToStudy,
  [PageId.QURAN_GOAL]: QuranGoal,
  [PageId.IMAN_EXAMPLE]: ImanExample,
  [PageId.BIBLE_PURPOSE]: BiblePurpose,
  [PageId.READ_OR_LISTEN]: ReadOrListen,
  [PageId.ANTISTRESS_MUSIC]: AntistressMusic,
  [PageId.BACKGROUND_MUSIC]: BackgroundMusic,
  [PageId.BACKGROUND_MUSIC_V2]: BackgroundMusic,
  [PageId.PLAN_TO_USE]: PlanToUse,
  [PageId.BIBLE_CONTENT]: BibleContent,
  [PageId.BIBLE_CONTENT_V2]: BibleContent,
  [PageId.BIBLE_CONTENT_V3]: BibleContentV3,
  [PageId.QURAN_CONTENT]: QuranContent,
  [PageId.QURAN_CONTENT_V2]: QuranContentV2,
  [PageId.GROWTH_PURPOSE]: GrowPurpose,
  [PageId.NARRATOR_VOICE]: NarratorVoice,
  [PageId.NARRATOR_VOICE_V2]: NarratorVoice,
  [PageId.PORN_TO_COPE]: PornToCope,
  [PageId.FEEL_EXHAUSTED]: FeelExhausted,
  [PageId.STAY_FOCUSED]: StayFocused,
  [PageId.FEEL_TIRED]: FeelTired,
  [PageId.HARD_TO_ACHIEVE]: HardToAchieve,
  [PageId.LOST_INTEREST]: LostInterest,
  [PageId.BOREDOM_SCROLLING]: BoredomScrolling,
  [PageId.ENERGY_LEVEL_V2]: EnergyLevel,
  [PageId.ENERGY_LEVEL_KARMA]: EnergyLevelKarma,
  [PageId.ENERGY_LEVEL_AYAH]: EnergyLevelKarma,
  [PageId.CONCENTRATION_IMPACT]: ConcentrationImpact,
  [PageId.AFFECTED_ARIA]: AffectedAria,
  [PageId.CURRENT_LIFESTYLE]: CurrentLifestyle,
  [PageId.FINANCIAL_MINDSET]: FinancialMindset,
  [PageId.INCOME_STABILITY]: IncomeStability,
  [PageId.BUDGET_CONFIDENCE]: BudgetConfidence,
  [PageId.BIGGEST_FINANCIAL_STRUGGLE]: BiggestFinancialStruggle,
  [PageId.OVERALL_STATE]: OverallState,
  [PageId.LAST_TIME_FOCUSED]: LastTimeFocused,
  [PageId.DOPAMINE_EFFECT]: DopamineEffect,
  [PageId.STRUGGLE_WITH_INSOMNIA]: StruggleWithInsomnia,
  [PageId.DESCRIBE_CHALLENGE]: DescribeChallenge,
  [PageId.LIFE_IMPACT]: LifeImpact,
  [PageId.MUSLIM_BACKGROUND]: MuslimBackground,
  [PageId.SELECT_FOCUS_AREA]: SelectFocusArea,
  [PageId.FEEL_BETTER_ABOUT]: FeelBetterAbout,
  [PageId.ENERGY_LATELY]: EnergyLately,
  [PageId.SLEEP_QUALITY]: SleepQuality,
  [PageId.FEEL_STRESSED]: FeelStressed,
  [PageId.DIGESTION_QUALITY]: DigestionQuality,
  [PageId.KNOWN_INGREDIENTS]: KnownIngredients,
  [PageId.FAITH_IN_WELLNESS]: FaithInWellness,
  [PageId.NATURAL_REMEDIES]: NaturalRemedies,
  [PageId.TRIED_SUNNAH_REMEDIES]: TriedSunnahRemedies,
  [PageId.WELLNESS_SUPPORT_TIME]: WellnessSupportTime,
  [PageId.GUIDE_FREQUENCY]: GuideFrequency,
  [PageId.STUDY_QURAN]: StudyQuran,
  [PageId.AYAH_GOAL]: AyahGoal,
  [PageId.KARMA_GOAL]: KarmaGoal,
  [PageId.SPEAK_ARABIC]: SpeakArabic,
  [PageId.QURAN_LESSONS]: QuranLessons,
  [PageId.ATTEND_COMMUNITY]: AttendCommunity,
  [PageId.FAMILIAR_WITH_CONCEPT]: FamiliarWithConcept,
  [PageId.WHAT_BROUGHT_YOU]: WhatBroughtYou,
  [PageId.RELATIONSHIP_STATUS]: RelationshipStatus,
  [PageId.RELATIONSHIP_GOING_ON]: RelationshipGoingOn,
  [PageId.REFLECTION_RESULT]: ReflectionResult,
  [PageId.CHILDHOOD_EXPERIENCE]: ChildhoodExperience,
  [PageId.RELATIONSHIP_WITH_CAREGIVER]: RelationshipWithCaregiver,
  [PageId.EMOTIONS_IN_FAMILY]: EmotionsInFamily,
  [PageId.ARIAS_TO_IMPROVE_V3]: AriasToImproveV3,
  [PageId.STUDY_BUDDHISM]: StudyBuddhism,
  [PageId.CHALLENGE_AREAS]: ChallengeAreasFactory,
  [PageId.CHALLENGE_AREAS_AYAH]: MultiChallengeAreas,
  [PageId.TRANSFORM_CHALLENGE_AREAS]: TransformChallengeAreas,
  [PageId.DAILY_GOAL]: DailyGoal,
  [PageId.BUDDHIST_PRACTICE]: BuddhistPractice,
  [PageId.KARMA_CONTENT]: KarmaContent,
  [PageId.LEARNING_STYLE]: LearningStyle,
  [PageId.LESSON_LENGTH]: LessonLength,
  [PageId.TRACK_YOUR_PROGRESS]: TrackYourProgress,
  [PageId.TURN_TO_GOD]: TurnToGod,
  [PageId.TURN_TO_ALLAH]: TurnToAllah,
  [PageId.HEAVY_LIFE]: HeavyLife,
  [PageId.OBSTACLES_TO_STUDY]: ObstaclesToStudy,
  [PageId.FAITH_OBSTACLE_DETAILS]: FaithObstacleDetails,
  [PageId.FAITH_EXAMPLE]: FaithExample,
  [PageId.STAY_MOTIVATED]: StayMotivated,
  [PageId.ARIAS_TO_SUPPORT]: AriasToSupport,
  [PageId.CONTENT_TYPE]: ContentType,
  [PageId.CONTENT_TYPE_V2]: ContentTypeV2,
  [PageId.READY_TO_GROW_CLOSER]: ReadyToGrowCloser,
  [PageId.QURAN_STUDY_TIME]: QuranStudyTime,
  [PageId.SINGLE_PRESENT_STRUGGLES]: SinglePresentStruggles,
  [PageId.ABILITIES]: Abilities,
  [PageId.NEW_THINGS]: NewThings,
  [PageId.GUILTY]: Guilty,
  [PageId.GUILTY_TYPE_AYAH]: GuiltyTypeAyah,
  [PageId.PROMICES_AYAH]: PromicesAyah,
  [PageId.QUOTE_AYAH]: QuoteAyah,
  [PageId.STORY_AYAH]: StoryAyah,
  [PageId.TYPICAL_DAY]: TypicalDay,
  [PageId.CALM_DOWN_AYAH]: CalmDownAyah,
  [PageId.OTHER_OPINION]: OtherOpinion,
  [PageId.INSTINCT_AYAH]: InstinctAyah,
  [PageId.INSPIRATION_AYAH]: InspirationAyah,
  [PageId.CARE_AYAH]: CareAyah,
  [PageId.STAY_ON_TRACK]: StayOnTrack,
  [PageId.MIND_AYAH]: MindAyah,
  [PageId.NEW_CHALLENGE_AYAH]: NewChallengeAyah,
  [PageId.READ_LISTEN_QURAN]: ReadListenQuran,
  [PageId.READING_PLACE_AYAH]: ReadingPlaceAyah,
  [PageId.ADVICE_AYAH]: AdviceAyah,
  [PageId.DISCOVER_AYAH]: DiscoverAyah,
  [PageId.QURAN_DISCUSSION]: QuranDiscussion,
  [PageId.ANGRY]: Angry,
  [PageId.NEGATIVE_SITUATIONS]: NegativeSituations,
  [PageId.OVERWHELMED]: Overwhelmed,
  [PageId.OUTCOME]: Outcome,
  [PageId.CRITICIZE]: Criticize,
  [PageId.UNCOMFORTABLE]: Uncomfortable,
  [PageId.REST]: Rest,
  [PageId.FINANCE_STRESS_LEVEL]: FinanceStress,
  [PageId.FAITH_DECISIONS]: FaithDecisions,
  [PageId.ANIMATED_BREAK]: AnimatedStepFactory,
  [PageId.COMMITMENT_LEVEL]: CommitmentLevel,
  [PageId.COMMITMENT_PROMISE]: CommitmentPromise,
  [PageId.STRUGGLE_FINANCES]: StruggleFinances,
  [PageId.MONEY_IN_LIFE]: MoneyInLife,
  [PageId.MONEY_VISION]: MoneyVision,
  [PageId.BETTER_FINANCES]: BetterFinances,
  // DecisionButtons
  [PageId.DIVE_DEEPER]: DiveDeeper,
  [PageId.PSALMS_UNDERSTANDING]: PsalmsUnderstanding,
  [PageId.SURAH_UNDERSTANDING]: SurahUnderstanding,
  [PageId.WISDOM_OF_PROVERBS]: WisdomOfProverbs,
  [PageId.EXPLICIT_CONTENT]: ExplicitContent,
  [PageId.REFERRED_BY]: ReferredBy,
  [PageId.BIBLE_PRAYER]: PrayerType,
  [PageId.MEDITATION_PRAYER]: PrayerType,
  [PageId.REFLACTION_PRAYER]: PrayerType,
  [PageId.ROSARY_PRAYER]: PrayerType,
  [PageId.FEEL_COMFORTABLE]: FeelingType,
  [PageId.FEEL_STRUGGLE]: FeelingType,
  [PageId.FEEL_DISCOMFORT]: FeelingType,
  [PageId.FEEL_PULLED]: FeelingType,
  [PageId.FEEL_UNSURE]: FeelingType,
  [PageId.FEEL_LOST]: FeelingType,
  [PageId.FEEL_WORRY]: FeelingType,
  [PageId.FEEL_UNSETTLED]: FeelingType,
  [PageId.FEEL_CONCERNED]: FeelingType,
  [PageId.TURN_ON_REMINDERS]: TurnOnReminders,
  [PageId.TURN_ON_REMINDERS_AYAH]: TurnOnRemindersAyah,
  [PageId.ENJOY_READING_DAILY]: EnjoyReadingDaily,
  [PageId.ENJOY_READING_AYAH]: EnjoyReadingAyah,
  [PageId.ENJOY_LISTENING_DAILY]: EnjoyListeningDaily,
  [PageId.ENJOY_LISTENING_AYAH]: EnjoyListeningAyah,
  [PageId.ENJOY_LISTENING_KARMA]: EnjoyListeningKarma,
  [PageId.POTENTIAL_BLOCK]: PotentialBlock,
  [PageId.DOPAMINE_DETOX]: DopamineDetox,
  [PageId.REFERRED_BY_V2]: ReferredBy,
  [PageId.READY_TO_RENEWAL]: ReadyToRenewal,
  [PageId.TEST_ALCOHOL]: TestAlcohol,
  [PageId.TEST_TATTOO]: TestTattoo,
  [PageId.TEST_COFFEE]: TestCoffee,
  [PageId.READY_TO_BEGIN]: ReadyToBegin,
  // Animation
  [PageId.PERSONAL_GROWTH_PROGRESS_V2]: PersonalGrowthProgressV2,
  [PageId.PERSONAL_GROWTH_PROGRESS_V3]: PersonalGrowthProgressV3,
  [PageId.PERSONAL_GROWTH_PROGRESS_V4]: PersonalGrowthProgressV3,
  [PageId.PEOPLE_LIKE_YOU]: PeopleLikeYou,
  [PageId.ANALYZING_ANSWERS]: AnalyzingAnswers,
  [PageId.ANALYZING_ANSWERS_AYAH]: AnalyzingAnswersAyah,
  [PageId.ANALYZING_ANSWERS_KARMA]: AnalyzingAnswersKarma,
  [PageId.TRANSFORM_LIFE_KARMA]: TransformLifeKarma,
  [PageId.ANALYZING_ANSWERS_BLESS]: AnalyzingAnswersBlessV4,
  [PageId.ANALYZING_LOADER]: AnalyzingAnswersV5,
  [PageId.GROWTH_PROFILE]: GrowthProfile,
  [PageId.PERSONALIZED_PLAN_KARMA]: PersonalizedPlanKarma,
  [PageId.PLAN_PREPARATION_KARMA]: PlanPreparationKarma,
  [PageId.PLAN_PREPARATION_AYAH]: PlanPreparationAyah,
  [PageId.SCRATCH_CARD]: Scratch,
  // Email
  [PageId.NAME]: Name,
  [PageId.NAME_V2]: NameV2,
  [PageId.EMAIL_V2]: Email,
  [PageId.EMAIL_V1]: EmailV1,
  [PageId.EMAIL_FACTORY]: EmailFactory,
  [PageId.EMAIL_CONSENT_V1]: EmailConsentVariant1,
  [PageId.DOWNLOAD_WELLNESS]: DownloadWellness,
  [PageId.APP_WELLNESS]: AppWellness,
  // Purchase
  [PageId.TRIAL_CHOICE]: ChooseTrialPrice,
  [PageId.PURCHASE_LONG]: PurchaseLong,
  [PageId.PURCHASE_LONG_V2]: PurchaseLongV2,
  [PageId.PURCHASE_LONG_V3]: PurchaseLongV3Factory,
  [PageId.PURCHASE_V3_KARMA_TRIAL]: PurchaseV3KarmaTrial,
  [PageId.PURCHASE_LONG_V4]: PurchaseLongV4,
  [PageId.PURCHASE_LONG_V5]: PurchaseLongV5,
  [PageId.PURCHASE_LONG_V6]: PurchaseLongV6,
  [PageId.PURCHASE_ARCHETYPE_AYAH]: PaywallArchetypeAyah,
  [PageId.WELLNESS_PAYWALL]: WellnessPaywall,
  [PageId.PURCHASE_AM]: PaywallUS,
  [PageId.PAYMENT]: PaymentLong,
  [PageId.PAYMENT_V2]: PaymentLong,
  // CancelOffer
  [PageId.CANCEL_OFFER_QUESTION_V1]: CancelOfferQuestionV1,
  [PageId.CANCEL_OFFER_QUESTION_V2]: CancelOfferQuestionV2,
  [PageId.CANCEL_OFFER_QUESTION_V3]: CancelOfferQuestionV3,
  [PageId.CANCEL_OFFER_SUBSCRIPTION_V1]: CancelOfferSubscriptionV1,
  [PageId.CANCEL_OFFER_SUBSCRIPTION_V2]: CancelOfferSubscriptionV2,
  [PageId.CANCEL_OFFER_SUBSCRIPTION_V3]: CancelOfferSubscriptionV3,
  [PageId.CANCEL_OFFER_SUBSCRIPTION_V4]: CancelOfferSubscriptionV4,
  [PageId.CANCEL_OFFER_SUBSCRIPTION_V5]: CancelOfferSubscriptionV5,
  // Upsell
  [PageId.UPSELL_GUIDE]: InappUpsell,
  [PageId.INAPP_PODCAST]: InappPodcast,
  [PageId.UPSELL_GUIDE_V2]: UpsellGuide,
  [PageId.UPSELL_PODCAST]: UpsellPodcast,
  [PageId.UPSELL_AYAH_PA]: UpsellAyahPornAddiction,
  [PageId.UPSELL_CANCEL_QUESTION_AYAH]: UpsellCancelQuestion,
  [PageId.UPSELL_CANCEL_OFFER_V1]: UpsellAddonsAyah,
  [PageId.UPSELL_ADDONS_AYAH]: UpsellAddonsAyah,
  [PageId.INAPP_VOICEOVER]: InappVoiceover,
  [PageId.INAPP_VOICEOVER_2]: InappVoiceover2,
  [PageId.INAPP_VOICEOVER_V3]: InappVoiceoverV3,
  [PageId.UPSELL_PARENTING]: UpsellParenting,
  [PageId.INAPP_HOW_TO]: InappHowTo,
  [PageId.INAPP_STRESS_RELIVE]: InappStressRelive,
  // SignUp
  [PageId.SIGNUP]: SignUp,
  [PageId.ACCOUNT]: Account,
}
